module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/your_project_ca-98ea2abddc0cadd958e78bc0c60ab511.png";